const buttonsMixin = {
	data() {
		return {
			displayWidth: window.innerWidth,
			isDesktopDevice: window.innerWidth > 1024,
			isTabletDevice: window.innerWidth > 600 && window.innerWidth <= 1024,
			isMobileDevice: window.innerWidth <= 600
		}
	},
	destroyed() {
		window.removeEventListener('resize', this.onChangeResize);
	},
	mounted() {
		window.addEventListener('resize', this.onChangeResize);
	},
	methods: {
		onChangeResize() {
			this.displayWidth = window.innerWidth;
			this.isTabletDevice = window.innerWidth > 600 && window.innerWidth <= 1024;
			this.isMobileDevice = window.innerWidth <= 600;
			this.isDesktopDevice = window.innerWidth > 1024;
		}
	}
}

export default buttonsMixin;
